export const SCRIPTS = [
  {
    id: 'blockchain_company_award',
    src: 'https://shareables.clutch.co/share/badges/139131/83698?utm_source=clutch_award_badge&utm_medium=image_embed',
    title: 'Top Clutch Blockchain Company 2023 Award',
  },
  {
    id: 'ethereum_company_award',
    src: 'https://shareables.clutch.co/share/badges/139131/83638?utm_source=clutch_award_badge&utm_medium=image_embed',
    title: 'Top Clutch Ethereum Company 2023 Award',
  },
  {
    id: 'initial_coin_offering_consulting_company_award',
    src: 'https://shareables.clutch.co/share/badges/139131/83616?utm_source=clutch_award_badge&utm_medium=image_embed',
    title: 'Top Clutch Initial Coin Offering Consulting Company 2023 Award',
  },
  {
    id: 'smart_contract_development_company_award',
    src: 'https://shareables.clutch.co/share/badges/139131/83902?utm_source=clutch_award_badge&utm_medium=image_embed',
    title: 'Top Clutch Smart Contract Development Company 2023 Award',
  },
]
